// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"120":"1821dd46","304":"111ff742","436":"6b12ae9a","590":"1bbddf07"}[chunkId] + ".chunk.css";
};